import { RequestStatus } from 'legacy/lut/configs/service'

import { IGeneralReportsState } from 'partner360/features/generalReports/models/state'

export const initialState: IGeneralReportsState = {
  data: [],
  selectedRoots: [],
  selectedReport: null,
  selectedFYear: 0,
  selectedRtm: '',
  searchStr: '',
  fetchStatus: RequestStatus.NONE,
}
